"use strict";

var _regeneratorRuntime = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = require("lodash");
/**
 * Factories are tasked with creating instances of their corresponding Entity and managing the internal cache for that Entity type.
 * So, for example, the Security Token Factory is tasked with fetching necessary data to instance a Security Token,
 * as well as fetching/refreshing the internal Security Token cache
 */


var Factory =
/*#__PURE__*/
function () {
  /**
   * Create a factory that can generate an entity
   */
  function Factory(eClass, context) {
    _classCallCheck(this, Factory);

    this.cache = {};
    this.Entity = eClass;
    this.context = context;
  }
  /**
   * Get an entity from the cache. Fetches the necessary data to create it if it isn't cached, refreshes it if it is
   *
   * @param uid - unique identifier for the entity
   */


  _createClass(Factory, [{
    key: "fetch",
    value: function fetch(uid) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var cache, context, instance, identifiers, props;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                cache = this.cache, context = this.context;
                instance = cache[uid];

                if (instance) {
                  _context.next = 11;
                  break;
                }

                identifiers = this.Entity.unserialize(uid);
                _context.next = 6;
                return this.generateProperties(uid);

              case 6:
                props = _context.sent;
                instance = new this.Entity(lodash_1.merge(identifiers, props), context);
                cache[uid] = instance;
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return this.refresh(uid);

              case 13:
                return _context.abrupt("return", instance);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
    /**
     * Get an entity from the cache. Creates it if it isn't cached, updates it if it is
     *
     * @param uid - unique identifier for the entity
     * @param params - constructor data for the entity
     */

  }, {
    key: "create",
    value: function create(uid, params) {
      var cache = this.cache,
          context = this.context;
      var instance = cache[uid];

      if (!instance) {
        var identifiers = this.Entity.unserialize(uid);
        instance = new this.Entity(lodash_1.merge(identifiers, params), context);
        cache[uid] = instance;
      } else {
        instance._refresh(params);
      }

      return instance;
    }
    /**
     * Fetch the data for an entity and updates its properties
     *
     * @param uid - unique identifier for the entity
     */

  }, {
    key: "refresh",
    value: function refresh(uid) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var instance, props;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                instance = this.cache[uid];

                if (instance) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                _context2.next = 5;
                return this.generateProperties(uid);

              case 5:
                props = _context2.sent;

                instance._refresh(props);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
    /**
     * Update an entity's properties in place
     *
     * @param uid - unique identifier for the entity
     * @param params - properties that should be updated
     */

  }, {
    key: "update",
    value: function update(uid, params) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var instance;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                instance = this.cache[uid];

                if (instance) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                instance._refresh(params);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }]);

  return Factory;
}();

exports.Factory = Factory;